import { render, staticRenderFns } from "./EpisodeList.vue?vue&type=template&id=24aecbca&scoped=true&"
import script from "./EpisodeList.vue?vue&type=script&lang=js&"
export * from "./EpisodeList.vue?vue&type=script&lang=js&"
import style0 from "./EpisodeList.vue?vue&type=style&index=0&id=24aecbca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24aecbca",
  null
  
)

export default component.exports